import { z } from 'zod'

export const mailingListRecipientFormSchema = z.object({
  email: z.string().email('Email invalide').max(255).trim().toLowerCase(),
  name: z.string().max(120).optional(),
})

export type MailingListRecipientFormValues = z.infer<typeof mailingListRecipientFormSchema>
